import { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch user info from the API
  const fetchUserInfo = async () => {
    try {
      const response = await fetch("/api/user-info", { method: "GET", credentials: "include" });
      if (response.ok) {
        const data = await response.json();
        setUserInfo(data);
        setError(null);
      } else {
        setUserInfo(null);
        const errorData = await response.json();
        setError(errorData.error || "Failed to fetch user info.");
      }
    } catch (err) {
      setUserInfo(null);
      setError("Error fetching user info.");
    } finally {
      setLoading(false);
    }
  };

  // Refresh user info manually
  const refreshUserInfo = () => {
    setLoading(true);
    fetchUserInfo();
  };

  // Logout user and clear context
  const logoutUser = async () => {
    try {
      const response = await fetch("/api/logout", { method: "POST", credentials: "include" });
      if (!response.ok) {
        throw new Error("Failed to log out");
      }
      setUserInfo(null); // Clear user info from context
    } catch (err) {
      console.error("Logout failed:", err);
      throw err; // Allow the caller to handle errors
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <UserContext.Provider
      value={{
        userInfo,
        error,
        loading,
        refreshUserInfo,
        logoutUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);


// THIS IS THE CODE CAUSING LOCALSTORAGE TO CLEAR

// import { createContext, useContext, useState, useEffect } from "react";

// const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [userInfo, setUserInfo] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchUserInfo = async () => {
//     try {
//       const response = await fetch("/api/user-info", {
//         method: "GET",
//         credentials: "include",
//         headers: {
//           "Cache-Control": "no-cache, no-store, must-revalidate",
//           "Pragma": "no-cache",
//           "Expires": "0"
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setUserInfo(data);
//         setError(null);
//       } else {
//         await handleInvalidSession(response);
//       }
//     } catch (err) {
//       handleFetchError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInvalidSession = async (response) => {
//     if (response.status === 401) {
//       await performClientSideLogout();
//     } else {
//       const errorData = await response.json();
//       setError(errorData.error || "Failed to fetch user info.");
//     }
//     setUserInfo(null);
//   };

//   const handleFetchError = (err) => {
//     setUserInfo(null);
//     setError("Error fetching user info.");
//     console.error("User info fetch error:", err);
//   };

//   const refreshUserInfo = () => {
//     setLoading(true);
//     fetchUserInfo();
//   };

//   const performClientSideLogout = async () => {
//     // Clear all client-side storage
//     if (typeof window !== "undefined") {
//       window.localStorage.clear();
//       window.sessionStorage.clear();
//     }
//     setUserInfo(null);
//     setError(null);
//   };

//   const logoutUser = async () => {
//     try {
//       const response = await fetch("/api/logout", {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Cache-Control": "no-cache, no-store, must-revalidate"
//         }
//       });

//       if (!response.ok) throw new Error("Failed to log out");

//       await performClientSideLogout();

//       // Force cache invalidation
//       if (typeof window !== "undefined") {
//         window.location.href = `/?nocache=${Date.now()}`;
//         window.location.reload(true);
//       }

//     } catch (err) {
//       console.error("Logout failed:", err);
//       await performClientSideLogout();
//       throw err;
//     }
//   };

//   useEffect(() => {
//     fetchUserInfo();
//   }, []);

//   return (
//     <UserContext.Provider
//       value={{
//         userInfo,
//         error,
//         loading,
//         refreshUserInfo,
//         logoutUser,
//         // Add forceUpdate function
//         forceUpdate: () => {
//           setUserInfo(null);
//           fetchUserInfo();
//         }
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUserContext = () => useContext(UserContext);